var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.badge)?_c('div',{staticClass:"tag is-small is-sponsored-badge has-background-primary\n    has-text-white has-text-weight-semibold"},[_vm._v(" "+_vm._s(_vm.badge)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }